import { FC, Fragment } from 'react';
import { BecomeADealer } from './become-a-dealer';
import { SystemSelector } from './system-selector';
import { WhereToBuy } from './where-to-buy';
import { BecomeAnInfluencer } from './become-an-influencer';
import { Seer2Card } from './seer2';
import PurchaseSection from '../product/PurchaseSection';

interface Props {
  props: {
    disabled: boolean;
    cards: {
      disabled: boolean;
      cardType: string;
    }[];
    sectionPadding: boolean;
  };
  className?: string;
  children?: React.ReactNode;
}

export const Cards: FC<Props> = (
  { props: { disabled, cards, sectionPadding } },
  className
) => {
  const cardTypes: Record<string, JSX.Element> = {
    'system-selector': <SystemSelector />,
    'where-to-buy': <WhereToBuy />,
    'become-a-dealer': <BecomeADealer />,
    'become-an-infulencer': <BecomeAnInfluencer />,
    SEER2: <Seer2Card />,
    'purchase-section': <PurchaseSection />,
  };

  const cardData = cards.filter((card) => !card.disabled);

  if (disabled) return null;

  return (
    <>
      {cardData.length > 1 && (
        <div className='grid w-full grid-cols-1 gap-9 md:grid-cols-2'>
          {cardData.map((cards, index) => {
            return (
              !cards.disabled && (
                <Fragment key={index}>{cardTypes[cards.cardType]}</Fragment>
              )
            );
          })}
        </div>
      )}

      {cardData.length === 1 &&
        ((!cardData[0].disabled && cardTypes[cardData[0].cardType]) || null)}
    </>
  );
};
